@if (dataForm) {
    <form [formGroup]="dataForm" class="without-default-focus">
        <div class="form-item form-item-help">
            <mat-form-field class="with-info-icon">
                <mat-label>Attribut</mat-label>
                <mat-select formControlName="attribute" required tabindex="1" (selectionChange)="onSelectedAttributeChange($event)">
                    @for (attribute of _attributes; track attribute) {
                        <mat-option [value]="attribute.id">
                            {{ attribute.header }}
                        </mat-option>
                    }
                </mat-select>
                @if (dataForm.controls['attribute']?.errors?.required && (dataForm.controls['attribute']?.dirty || dataForm.controls['attribute'].touched)) {
                    <mat-error>Le champ 'Attribut' est obligatoire</mat-error>
                }
            </mat-form-field>
            <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO État" matTooltipPosition="right"></fa-icon>
        </div>
        @if (selectedAttribute) {
            <div class="form-item form-item-help">
                @switch (selectedAttribute.type) {
                    @case (propertyType.Long) {
                        <!-- Affichage d'un attribut de type 'Entier' -->
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur</mat-label>
                            <input matInput formControlName="value" autocomplete="off" required (contextmenu)="$event.preventDefault(); onInputRightClick('value', $event)" />
                            @if (dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)) {
                                <mat-error>Le champ 'Valeur' est obligatoire</mat-error>
                            }
                            @if (dataForm.controls['value']?.hasError('invalidError')) {
                                <mat-error>
                                    <span title="La valeur n'est pas un nombre entier valide.">La valeur n'est pas un nombre entier valide.</span>
                                </mat-error>
                            }
                        </mat-form-field>
                    }
                    @case (propertyType.Decimal) {
                        <!-- Affichage d'un attribut de type 'Decimal' -->
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur</mat-label>
                            <input matInput formControlName="value" autocomplete="off" required (contextmenu)="$event.preventDefault(); onInputRightClick('value', $event)" />
                            @if (dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)) {
                                <mat-error>Le champ 'Valeur' est obligatoire</mat-error>
                            }
                            @if (dataForm.controls['value']?.hasError('invalidError')) {
                                <mat-error>
                                    <span title="La valeur n'est pas un nombre décimal valide.">La valeur n'est pas un nombre décimal valide.</span>
                                </mat-error>
                            }
                        </mat-form-field>
                    }
                    @case (propertyType.Date) {
                        <!-- Affichage d'un attribut de type 'Date' -->
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur</mat-label>
                            <input
                                matInput
                                [matDatepicker]="datepicker"
                                formControlName="value"
                                required
                                (contextmenu)="$event.preventDefault(); onInputRightClick('value', $event)" />
                            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                            <mat-datepicker #datepicker></mat-datepicker>
                            @if (dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)) {
                                <mat-error>Le champ 'Valeur' est obligatoire</mat-error>
                            }
                        </mat-form-field>
                    }
                    @case (propertyType.DateAndTime) {
                        <!-- Affichage d'un attribut de type 'Date & heure' -->
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur</mat-label>
                            <input
                                matInput
                                [ngxMatDatetimePicker]="picker"
                                formControlName="value"
                                required
                                (contextmenu)="$event.preventDefault(); onInputRightClick('value', $event)" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <ngx-mat-datetime-picker #picker></ngx-mat-datetime-picker>
                            @if (dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)) {
                                <mat-error>Le champ 'Valeur' est obligatoire</mat-error>
                            }
                        </mat-form-field>
                    }
                    @case (propertyType.List) {
                        @if (selectedAttribute.custom === true) {
                            <!-- Affichage d'un attribut de type 'Liste' -->
                            <mat-form-field class="with-info-icon">
                                <mat-label>Valeur</mat-label>
                                <mat-select formControlName="value" required>
                                    <mat-option [value]="">Aucune</mat-option>
                                    @for (attributeValue of selectedAttribute.attributeValueDefinitions; track attributeValue) {
                                        <mat-option [value]="attributeValue.id.toString()">{{ attributeValue.name }}</mat-option>
                                    }
                                </mat-select>
                                @if (dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)) {
                                    <mat-error>Le champ 'Valeur' est obligatoire</mat-error>
                                }
                            </mat-form-field>
                        } @else if (selectedAttribute.name === 'FolderStateId') {
                            <!-- Affichage de l'attribut 'Etat' -->
                            <mat-form-field class="with-info-icon">
                                <mat-label>Valeur</mat-label>
                                <mat-select formControlName="value" required>
                                    <mat-option [value]="">Aucune</mat-option>
                                    @for (state of _folderStates; track state) {
                                        <mat-option [value]="state.id.toString()">{{ state.name }}</mat-option>
                                    }
                                </mat-select>
                                @if (dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)) {
                                    <mat-error>Le champ 'Valeur' est obligatoire</mat-error>
                                }
                            </mat-form-field>
                        }
                    }
                    @case (propertyType.ListCustomers) {
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur</mat-label>
                            <mat-select formControlName="value" required>
                                <mat-option [value]="">Aucune</mat-option>
                                @for (attributeValue of selectedAttribute.attributeValueDefinitions; track attributeValue) {
                                    <mat-option [value]="attributeValue.id.toString()">{{ attributeValue.name }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                                Le champ 'Valeur' est obligatoire
                            </mat-error>
                        </mat-form-field>
                    }
                    @case (propertyType.ListUsers) {
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur</mat-label>
                            <mat-select formControlName="value" required>
                                <mat-option [value]="">Aucune</mat-option>
                                @for (user of _users; track user) {
                                    <mat-option [value]="user.id.toString()">{{ user.displayName }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                                Le champ 'Valeur' est obligatoire
                            </mat-error>
                        </mat-form-field>
                    }
                    @case (propertyType.AutocompletionByApi) {
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur</mat-label>
                            <input matInput type="text" formControlName="value" [matAutocomplete]="auto" />
                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (closed)="onAutocompleteClosed()" (optionSelected)="onAutocompleteItemSelected($event)">
                                <mat-option *ngFor="let autocompletionValue of autocompletionValues | async" [value]="autocompletionValue">{{ autocompletionValue }}</mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                                Le champ 'Valeur' est obligatoire
                            </mat-error>
                        </mat-form-field>
                    }
                    @case (propertyType.Color) {
                        <!-- Affichage d'un attribut de type 'Couleur' -->
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur</mat-label>
                            <mat-select formControlName="value" ngClass="bak-{{ dataForm.get('value').value }}-color" required>
                                <mat-option value="">Aucune</mat-option>
                                <mat-option class="mat-option-green-color" value="green"></mat-option>
                                <mat-option class="mat-option-orange-color" value="orange"></mat-option>
                                <mat-option class="mat-option-red-color" value="red"></mat-option>
                                <mat-option class="mat-option-grey-color" value="grey"></mat-option>
                                <mat-option class="mat-option-light-blue-color" value="lightBlue"></mat-option>
                                <mat-option class="mat-option-dark-blue-color" value="darkBlue"></mat-option>
                            </mat-select>
                            @if (dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)) {
                                <mat-error>Le champ 'Valeur' est obligatoire</mat-error>
                            }
                        </mat-form-field>
                    }
                    @default {
                        <!-- Affichage d'un attribut de type 'Texte' -->
                        <mat-form-field class="with-info-icon">
                            <mat-label>Valeur</mat-label>
                            <input
                                matInput
                                type="text"
                                formControlName="value"
                                autocomplete="off"
                                required
                                (contextmenu)="$event.preventDefault(); onInputRightClick('value', $event)" />
                            @if (dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)) {
                                <mat-error>Le champ 'Valeur' est obligatoire</mat-error>
                            }
                            @if (dataForm.controls['value']?.hasError('pattern')) {
                                <mat-error>
                                    <span title="Le champ doit respecter l'expression régulière : {{ selectedAttribute.format }}.">
                                        Le champ doit respecter l'expression régulière : {{ selectedAttribute.format }}.
                                    </span>
                                </mat-error>
                            }
                        </mat-form-field>
                    }
                }
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Valeur" matTooltipPosition="right"></fa-icon>
            </div>
        }
    </form>
}
